jQuery(document).ready(function($){
    setSliderHeight();
    var sliderResize;
    window.addEventListener('resize', function() {
        clearTimeout(sliderResize);
        sliderResize = setTimeout(setSliderHeight, 500);
    });

    $('.ub-slider').each(function(ubId){
        var $ubSlider=$(this);
        $ubSlider.attr('id','ub-slider-'+ubId);
        var isFeature=false;
        const isDetailed = $ubSlider.hasClass('detailed')

        var $sliderWrap=$ubSlider.find('.slider__wrapper');

        var $slides=$ubSlider.find('.ub-slider__slides>.slide');
        var $ubControls=$('<div class="ub-slider__controls-wrapper"><div class="ub-slider__controls">' +
            '<div class="ub-slider__controls-prev"><button type="button" class=""><span class="sr-only">Previous Slide</span></button></div>' +
            '<div class="ub-slider__controls-next"><button type="button" class=""><span class="sr-only">Next Slide</span></button></div></div></div>');

        var $ubSliderNav='';

        if($ubSlider.hasClass('feature') || $ubSlider.hasClass('quickLook') ){
            isFeature=true;

            $slides.each(function (i) {
                var $this = $(this);
                $this.attr('id', 'ub-slide-' + ubId + '-' + i);
                if($this.data('color') && $ubSlider.hasClass('feature')){var $caption=$this.find('.slider__caption');
                    $caption.css('backgroundColor',$this.data('color'));
                    $caption[0].alpha(75);
                }
            });
        }else if($slides.length>=2 && $ubSlider.find('.ub-slider__nav').length===0) {

            $ubSliderNav = $('<ul class="ub-slider__nav">');
            $slides.each(function (i) {
                var $this = $(this);
                const  style = $this.attr('class').split(' ')
                    .filter(function(className){ return className.indexOf('-bg')!==-1 || className.indexOf('-text')!==-1})
                    .join(' ')


                const color = $this.attr('data-color')

                $this.attr('id', 'ub-slide-' + ubId + '-' + i);
                var $navItem = $('<li class="ub-slider__nav-item nav-item"><button data-slide="' + i + '" ' + (color?' data-color="'+ color + '" ':'') + (style?' data-style="' + style + '" ':'') + '"><span class="sr-only">Slide ' + i + '</span><span id="current-nav" class="sr-only">(Current Slide)</span></button></li>');
                $ubSliderNav.append($navItem);
            });
        }
        if($slides.length<2){
            $ubSlider.addClass('no-controls');
            $ubControls='';
        }
        var $liveRegion = $('<div aria-live="polite" aria-atomic="true" class="sr-only liveregion">');

        if($sliderWrap.hasClass('block-slider') ||  $sliderWrap.hasClass('upsell-slider')){
          var $navElement = '';
          if($sliderWrap.hasClass('block-slider')){
          $navElement= $sliderWrap.find('li.slide').find('.block__image');
          }else{
          $navElement= $sliderWrap.find('li.slide').find('.quickview.primary');
          }

            var $navWrap = $('<div class="slider-nav-wrapper">');
            $navWrap.append($ubControls);
            $navWrap.append($ubSliderNav);
            $navWrap.append($liveRegion);
            $navElement.after($navWrap)
        } else if ($sliderWrap.length) {
            $sliderWrap.append($ubControls);
            $sliderWrap.append($ubSliderNav);
            $sliderWrap.append($liveRegion);
        }else{
            $ubSlider.append($ubControls);
            $ubSlider.append($ubSliderNav);
            $ubSlider.append($liveRegion);
        }

        goToSlide(0);

        $ubSlider.find('.nav-item button').on('click',function(){
            var $this=$(this);
            goToSlide($this.data('slide'));
        });
        $ubSlider.find('.ub-slider__controls-prev button').on('click',function(){
            goToSlide('prev');
        })
        $ubSlider.find('.ub-slider__controls-next button').on('click',function(){
            goToSlide('next');
        })

        function goToSlide(slide){
            if(slide==='next'){
                slide=$ubSlider.find('.next-slide').index();
            }else if(slide==='prev'){
                slide=$ubSlider.find('.prev-slide').index();
            }

            var new_next=slide+1;
            var new_prev=slide-1;
            if(new_next === $slides.length) {
                new_next = 0;
            } else if(new_prev < 0) {
                new_prev = $slides.length-1;
            }
            $ubSlider.find('.slide').removeClass('next-slide prev-slide current').attr('aria-hidden',true);
            $ubSlider.find('.slide a').attr('tabindex','-1'); // set tabindex -1 to focusable element when aria-hidden is true
            $slides.eq(new_next).addClass('next-slide');
            $slides.eq(new_prev).addClass('prev-slide');
            let $current=$slides.eq(slide).addClass('current').attr('aria-hidden',false);
            $slides.eq(slide).find('a').removeAttr('tabindex');
            if(!$current.hasClass('ff-slide') && $current.find('.freezeframe').length){
                $current.addClass('ff-slide')
                new Freezeframe({
                    selector: $current.find('.freezeframe')[0],
                    trigger: 'click',
                    overlay: true
                });
            }

            if ($sliderWrap.hasClass("upsell-slider") || $sliderWrap.hasClass("block-slider")) {
                $ubSlider
                    .find("li.slide.current")
                    .find(".nav-item")
                    .removeClass("current")
                    .eq(slide)
                    .addClass("current");
            } else {
                $ubSlider
                    .find(".nav-item")
                    .removeClass("current")
                    .eq(slide)
                    .addClass("current");
            }

            $ubSlider.find('.ub-slider__slides>.slide:first-child').css('margin-left','-' + (slide * 100) +'%');

            if(isFeature || isDetailed){
                var $btn=$ubSlider.find('.nav-item.current button');
                var $feature_nav, $class='';
                if($ubSlider.hasClass('feature') && $slides.length<2) {
                    $feature_nav=$ubSlider.find('.feature__nav');
                    $feature_nav.remove();
                }else if($ubSlider.hasClass('feature')) {
                    $feature_nav=$ubSlider.find('.feature__nav');
                    $class='feature__nav';
                }else if($ubSlider.hasClass('quickLook')){
                    $feature_nav=$ubSlider.find('.quickLook__nav');
                    $class='quickLook__nav';
                }else if($ubSlider.hasClass('detailed')){
                    $feature_nav=$ubSlider.find('.ub-slider__controls-wrapper');
                    $class='ub-slider__controls-wrapper';
                }
                $feature_nav.attr('style','');

                if($btn.data('style')!==undefined && $btn.data('style')!==''){

                    $feature_nav.attr('class',$class).addClass($btn.data('style'));
                    if( $btn.data('style').indexOf('other-bg')!==-1){
                        $feature_nav.attr('style','background-color:'+$current.data('color')+';');
                    }
                }else{
                    $feature_nav.attr('class',$class).addClass('no-color');
                }
            }
            var $thmbNav=$ubSlider.find('.image__nav ');


            if($thmbNav.length && slide>2){
                var $thmb1=$ubSlider.find('.gallery-nav-wrapper .nav-item:first-child');
                $thmb1.css('margin-left','-'+((slide-2)*116)+'px');
            }else if($thmbNav.length && slide===0){
                var $thmb1=$ubSlider.find('.gallery-nav-wrapper .nav-item:first-child');
                $thmb1.css('margin-left','0');
            }

            if ($ubSlider.hasClass("eyebrow-slider")) {
              window.dataLayer = window.dataLayer || [];
              dataLayer.push({
                event: "ub_event_eyebrow_slider_" + slide,
              });
            }
        }


    });


    function setSliderHeight(){
        var $heroSlides=$('.hero-slides');
        var sliderHeight=$heroSlides.css('height');
        if($heroSlides.length){
            $heroSlides.css('height','calc('+sliderHeight+' - '+$('header').height()+'px)');
        }
        if($('.slide-video').length){
            $('.slide-video').each(function(){
                $(this).find('video').css('height',$heroSlides.height() - $('header').height() + 'px');
            });
        }
    }
});

HTMLElement.prototype.alpha = function(a) {
    current_color = getComputedStyle(this).getPropertyValue("background-color");
    match = /rgba?\((\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(,\s*\d+[\.\d+]*)*\)/g.exec(current_color)
    a = a > 1 ? (a / 100) : a;
    this.style.backgroundColor = "rgba(" + [match[1],match[2],match[3],a].join(',') +")";
}